document.addEventListener('DOMContentLoaded', () => {
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('.diagnostic-steps__details').forEach((details) => {
    const summary = details.querySelector('.diagnostic-steps__summary');

    if (!summary) {
      return;
    }

    let animation = null;
    let animationState = details.open ? 'open' : 'closed';

    const shouldAnimate = () => (
      !reducedMotionQuery.matches && document.body.dataset.accessibility !== 'true'
    );

    const clearAnimationStyles = () => {
      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
    };

    const cancelAnimation = () => {
      if (!animation) {
        return;
      }

      animation.cancel();
      animation = null;
    };

    const finishToggle = (isOpen) => {
      cancelAnimation();
      details.open = isOpen;
      animationState = isOpen ? 'open' : 'closed';
      clearAnimationStyles();
    };

    const measureHeight = (isOpen) => {
      details.open = isOpen;
      details.style.height = 'auto';

      return details.getBoundingClientRect().height;
    };

    const animateToggle = (isOpen) => {
      const startHeight = details.getBoundingClientRect().height;

      cancelAnimation();

      const endHeight = measureHeight(isOpen);

      if (!isOpen) {
        details.open = true;
      }

      if (!shouldAnimate() || Math.abs(endHeight - startHeight) < 1) {
        finishToggle(isOpen);
        return;
      }

      details.style.height = `${startHeight}px`;
      details.style.overflow = 'hidden';
      animationState = isOpen ? 'opening' : 'closing';

      const duration = Math.min(
        520,
        Math.max(320, Math.abs(endHeight - startHeight) * 0.12)
      );

      animation = details.animate(
        {
          height: [`${startHeight}px`, `${endHeight}px`]
        },
        {
          duration,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
        }
      );

      animation.addEventListener('finish', () => {
        animation = null;
        details.open = isOpen;
        animationState = isOpen ? 'open' : 'closed';
        clearAnimationStyles();
      }, { once: true });
    };

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      const willOpen = animationState === 'closed' || animationState === 'closing';

      animateToggle(willOpen);
    });
  });
});
